/* ========================================================================
   Navigation
 ========================================================================== */

app.navigation = (function () {
  'use strict';

  const KEY_ENTER = 13;
  const KEY_SPACE = 32;

  const _trigger = document.querySelector('[data-main-nav-trigger]');
  const _container = document.querySelector('[data-main-nav-container]');
  const _body = document.querySelector('body');
  const _floatingTrigger = document.querySelector(
    '[data-floating-nav-trigger]'
  );

  function init() {
    initMenu();
    initMijnThebeNav();
    initSearchBox();
    initSubmenu();
    initFloatingTrigger();
  }

  function initMenu() {
    if (!_trigger || !_container) return;

    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('pageWrapper')) {
        closeMenu(false);
      }
    });

    _trigger.addEventListener('click', (event) => {
      toggleMenu(false);
    });

    _trigger.addEventListener('keydown', (event) => {
      switch (event.keyCode) {
        case KEY_ENTER:
        case KEY_SPACE:
          event.preventDefault();
          toggleMenu(true);
      }
    });

    _container.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu(true);
      }
    });
  }

  function toggleMenu(setFocus) {
    setFocus = setFocus || false;

    if (_trigger.classList.contains('is-active') === false) {
      openMenu(setFocus);
    } else {
      closeMenu(setFocus);
    }
  }

  function openMenu(setFocus) {
    setFocus = setFocus || false;

    _trigger.classList.add('is-active');
    _container.classList.add('is-active');
    _container.style.visibility = 'visible';
    _body.classList.add('has-open-menu');

    // a11y: switch focus to first link
    if (setFocus) _container.querySelector('[data-sub-nav-trigger]').focus();

    // a11y: update aria attributes
    _trigger.setAttribute('aria-label', _trigger.dataset.closeText);
    _trigger.setAttribute('aria-expanded', true);

    // DATALAYER
    app.dataLayer.pushEvent('menuClick', {
      pageUrl: window.location.pathname,
    });
  }

  function closeMenu(setFocus) {
    setFocus = setFocus || false;

    resetSubmenu();

    _trigger.classList.remove('is-active');
    _container.classList.remove('is-active');
    _body.classList.remove('has-open-menu');

    // a11y: switch focus back to trigger
    if (setFocus) _trigger.focus();

    // a11y: update aria attributes
    _trigger.setAttribute('aria-label', _trigger.dataset.openText);
    _trigger.setAttribute('aria-expanded', false);

    window.setTimeout(() => {
      _container.style.visibility = 'hidden';
    }, 500);
  }

  function initFloatingTrigger() {
    if (!_floatingTrigger) return;

    let scrolling = false;

    _floatingTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => openMenu(), 500);
    });

    window.addEventListener(
      'scroll',
      () => {
        scrolling = true;
      },
      { passive: true }
    );

    setInterval(() => {
      if (scrolling === false) return;
      scrolling = false;

      if (window.scrollY > 700) {
        if (_floatingTrigger.classList.contains('is-in-view')) return;
        _floatingTrigger.classList.add('is-in-view');
      } else {
        if (_floatingTrigger.classList.contains('is-in-view') === false) return;
        _floatingTrigger.classList.remove('is-in-view');
      }
    }, 100);
  }

  function initSearchBox() {
    const trigger = document.querySelector('[data-search-trigger]');
    const container = document.querySelector('[data-search-container]');
    const close = document.querySelector('[data-search-close]');

    if (!trigger || !container || !close) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();

      if (trigger.classList.contains('is-active') === false) {
        trigger.classList.add('is-active');
        container.style.visibility = 'visible';
        container.classList.add('is-active');
        container.querySelector('input').focus();

        // a11y: update aria attributes
        trigger.setAttribute('aria-expanded', true);

        // DATALAYER
        app.dataLayer.pushEvent('searchClick', {
          pageUrl: window.location.pathname,
          pagePart: 'header',
        });
      }
    });

    close.addEventListener('click', (event) => {
      event.preventDefault();
      closeSearchBox(trigger, container);
    });

    container.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeSearchBox(trigger, container, body);
      }
    });
  }

  function closeSearchBox(trigger, container) {
    trigger.classList.remove('is-active');
    container.classList.remove('is-active');

    // a11y: update aria attributes
    trigger.setAttribute('aria-expanded', false);
    trigger.focus();

    window.setTimeout(() => {
      container.style.visibility = 'hidden';
    }, 250);
  }

  function initSubmenu() {
    const triggers = document.querySelectorAll('[data-sub-nav-trigger]');

    if (!triggers) return;

    triggers.forEach((trigger) => {
      const parent = trigger.parentNode;
      const subnav = parent.querySelector('[data-sub-nav-container]');

      if (!parent || !subnav) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        if (parent.classList.contains('is-active') === false) {
          // close all open submenus
          resetSubmenu();

          parent.classList.add('is-active');
          util.slideDown(subnav, 250);

          // a11y: update aria attributes
          trigger.setAttribute('aria-label', trigger.dataset.closeText);
          trigger.setAttribute('aria-expanded', true);
        } else {
          util.slideUp(subnav, 250);
          parent.classList.remove('is-active');

          // a11y: update aria attributes
          trigger.setAttribute('aria-label', trigger.dataset.openText);
          trigger.setAttribute('aria-expanded', false);
        }
      });
    });
  }

  function resetSubmenu() {
    const triggers = document.querySelectorAll(
      '[data-sub-nav-trigger][aria-expanded="true"]'
    );

    if (!triggers) return;

    triggers.forEach((trigger) => {
      const parent = trigger.parentNode;
      const subnav = parent.querySelector('[data-sub-nav-container]');

      if (!parent || !subnav) return;

      util.slideUp(subnav, 250);
      parent.classList.remove('is-active');

      // a11y: update aria attributes
      trigger.setAttribute('aria-label', trigger.dataset.openText);
      trigger.setAttribute('aria-expanded', false);
    });
  }

  var mijnThebeTrigger = null;
  var mijnThebeContainer = null;

  function initMijnThebeNav() {
    mijnThebeTrigger = document.querySelector('[data-mijn-thebe-trigger]');
    mijnThebeContainer = document.querySelector('[data-mijn-thebe-container]');

    if (!mijnThebeTrigger || !mijnThebeContainer) return;

    mijnThebeTrigger.addEventListener('click', (event) =>
      mijnThebeNavClick(event)
    );

    mijnThebeContainer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMijnThebeNav();
      }
    });

    document.addEventListener('click', (event) => {
      if (
        event.target.classList.contains('mijnThebeNav__container') === false
      ) {
        closeMijnThebeNav();
      }
    });
  }

  function mijnThebeNavClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (mijnThebeContainer.classList.contains('is-active') === false) {
      openMijnThebeNav();
    } else {
      closeMijnThebeNav();
    }
  }

  function openMijnThebeNav() {
    if (!mijnThebeTrigger || !mijnThebeContainer) return;
    mijnThebeContainer.classList.remove('is-closed');
    mijnThebeContainer.classList.add('is-active');

    // a11y: update aria attributes
    mijnThebeTrigger.setAttribute(
      'aria-label',
      mijnThebeTrigger.dataset.closeText
    );
    mijnThebeTrigger.setAttribute('aria-expanded', true);
  }

  function closeMijnThebeNav() {
    if (!mijnThebeTrigger || !mijnThebeContainer) return;
    if (mijnThebeContainer.classList.contains('is-active') === false) return;

    mijnThebeContainer.classList.remove('is-active');

    window.setTimeout(() => {
      mijnThebeContainer.classList.add('is-closed');
    }, 250);

    // a11y: update aria attributes
    mijnThebeTrigger.setAttribute(
      'aria-label',
      mijnThebeTrigger.dataset.openText
    );
    mijnThebeTrigger.setAttribute('aria-expanded', false);
  }

  // Expose public functions and variables
  return {
    initMenu: initMenu,
    init: init,
  };
})();
